<script setup lang="ts" generic="Color extends string">
import type { NavigationItemsCollectionItem } from '@fondof-ui/types'
import { contentfulUrl } from '@internal/format-contentful'

const props = defineProps<{
  item: NavigationItemsCollectionItem
  color?: Color
}>()
</script>
<template>
  <li
    v-if="props.item?.url && props.item?.label"
    class="whitespace-nowrap font-sans text-sm !leading-[1.55] transition-all duration-300 ease-in-out hover:translate-x-2"
  >
    <span
      v-if="props.item.url.includes('#uc-corner-modal-show')"
      class="cursor-pointer"
      onclick="UC_UI.showSecondLayer();"
      onkeydown="if (event.keyCode === 13) UC_UI.showSecondLayer();"
      tabindex="0"
      aria-haspopup
      :aria-label="props.item.label"
    >
      {{ props.item.label }}
    </span>
    <a
      v-else
      :class="['no-underline', props.color]"
      :href="contentfulUrl(props.item.url)"
      data-gtm-attr="footer_link"
      :data-gtm-label="props.item.label"
    >
      {{ props.item.label }}
    </a>
  </li>
</template>
